import { render, staticRenderFns } from "./WhatsappTemplate.vue?vue&type=template&id=721c0df2&scoped=true&"
import script from "./WhatsappTemplate.vue?vue&type=script&lang=js&"
export * from "./WhatsappTemplate.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappTemplate.vue?vue&type=style&index=0&id=721c0df2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721c0df2",
  null
  
)

export default component.exports